/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";

import store from "@/store/store";

import firebase from "firebase/app";
import "firebase/auth";

import { DEFAULT_LANG } from "@/constants";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/VesselTracking.vue"),
      children: [
        // =============================================================================
        // VesselTracking Routes
        // =============================================================================
        {
          path: "/",
          redirect: "/vesselTracking/RealtimeMonitoring"
        },

        {
          path: "/vesselTracking/RealtimeMonitoring",
          name: "RealtimeMonitoring",
          component: () =>
            import("./views/vesselTracking/RealtimeMonitoring.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/vesselTracking/BaseStation",
          name: "BaseStation",
          component: () => import("./views/vesselTracking/BaseStation.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "Base station", active: true }
            ],
            pageTitle: "Base station",
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/Vessel",
          name: "Vessel",
          component: () => import("./views/vesselTracking/Vessel.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "Vessel", active: true }
            ],
            pageTitle: "Vessel",
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/Report",
          name: "Report",
          component: () => import("./views/vesselTracking/VesselReport.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "Report (ระบบฐานข้อมูลเรือ Tanker และการเชื่อมโยงข้อมูล) ", active: true }
            ],
            pageTitle: "Report",
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/vesselTracking/EventNotification",
          name: "EventNotification",
          component: () =>
            import("./views/vesselTracking/EventNotification.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "Event notification", active: true }
            ],
            pageTitle: "Event notification",
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/vesselTracking/Zone",
          name: "Zone",
          component: () => import("./views/vesselTracking/Zone.vue"),
          meta: {
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/Listzone",
          name: "Listzone",
          component: () => import("./views/vesselTracking/ListZone.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "Zone", active: true }
            ],
            pageTitle: "Zone",
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/Group",
          name: "Group",
          component: () => import("./views/vesselTracking/VesselGroup.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "Vessel group", active: true }
            ],
            pageTitle: "Vessel group",
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/Mid",
          name: "Mid",
          component: () => import("./views/vesselTracking/Mid.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "MID", active: true }
            ],
            pageTitle: "MID",
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/ShipType",
          name: "ShipType",
          component: () => import("./views/vesselTracking/ShipType.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "Ship type", active: true }
            ],
            pageTitle: "Ship type",
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/NavigationStatus",
          name: "NavigationStatus",
          component: () =>
            import("./views/vesselTracking/NavigationStatus.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "Navigation status", active: true }
            ],
            pageTitle: "Navigation status",
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/PositionFixType",
          name: "PositionFixType",
          component: () => import("./views/vesselTracking/PositionFixType.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "Position fix type", active: true }
            ],
            pageTitle: "Position fix type",
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/EditZone",
          name: "EditZone",
          component: () => import("./views/vesselTracking/EditZone.vue"),
          meta: {
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/users",
          name: "users",
          component: () => import("./views/vesselTracking/Users.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "Users", active: true }
            ],
            pageTitle: "Users",
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/editVesselGroup",
          name: "editVesselGroup",
          component: () => import("./views/vesselTracking/editVesselGroup.vue"),
          meta: {
            breadcrumb: [
              { title: "Realtime monitoring", url: "/" },
              { title: "Vessel group", url: "/vesselTracking/Group" },
              { title: "Eit vessel group", active: true }
            ],
            pageTitle: "Edit vessel group",
            rule: "hasRoleAdmin"
          }
        },
        {
          path: "/vesselTracking/vesselTrackingHistory",
          name: "vesselTrackingHistory",
          component: () =>
            import("./views/vesselTracking/vesselTrackingHistory.vue"),
          meta: {
            pageTitle: "Vessel History",
            rule: "hasRoleViewer"
          }
        },
        // {
        //   path: '/vesselTracking/DetailEventNotification',
        //   name: 'DetailEventNotification',
        //   component: () => import('./views/vesselTracking/DetailEventNotification.vue'),
        //   meta: {
        //     rule: 'hasRoleEditor'
        //   },
        // },

        // =============================================================================
        // Theme Routes
        // =============================================================================

        {
          path: "/dashboard/appenglish",
          name: "dashboardAppenglish",
          component: () => import("./views/DashboardAppenglish.vue"),
          meta: {
            rule: "hasRoleEditor"
          }
        },

        // =============================================================================
        // Settings Routes
        // =============================================================================
        {
          path: "/settings/users",
          name: "users",
          component: () => import("./views/settings/UserListView.vue"),
          meta: {
            rule: "hasRoleAdmin"
          }
        },
        // =============================================================================
        // Profiles Routes
        // =============================================================================
        {
          path: "/settings/me",
          name: "me",
          component: () => import("./views/settings/Me.vue"),
          meta: {
            // breadcrumb: [
            //     { title: 'Home', url: '/' },
            //     { title: 'Users', url: '/settings/users' },
            //     { title: 'My Profile', active: true },
            // ],
            // pageTitle: 'My Profile',
            rule: "hasRoleEditor"
          }
        }

        // =============================================================================
        // Pages Routes
        // =============================================================================
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/vesselTracking/DetailReport",
          name: "DetailReport",
          component: () => import("./views/vesselTracking/DetailReport.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/vesselTracking/DetailNotification",
          name: "DetailNotification",
          component: () =>
            import("./views/vesselTracking/DetailNotification.vue"),
          meta: {
            rule: "hasRoleEditor"
          }
        },
        {
          path: "/callback",
          name: "authCallback",
          component: () => import("@/views/Callback.vue"),
          meta: {
            rule: "hasRoleEditor"
          }
        },
        {
          path: "/pages/login",
          name: "pageLogin",
          component: () => import("@/views/pages/Login.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/pages/register",
          name: "pageRegister",
          component: () => import("@/views/pages/Register.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/pages/forgot-password",
          name: "pageForgotPassword",
          component: () => import("@/views/pages/ForgotPassword.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/pages/reset-password/:resetToken",
          name: "pageResetPassword",
          component: () => import("@/views/pages/ResetPassword.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/pages/error-404",
          name: "pageError404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/pages/not-authorized",
          name: "pageNotAuthorized",
          component: () => import("@/views/pages/NotAuthorized.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/pages/emailNotVerified",
          name: "pageEmailNotVerified",
          component: () => import("@/views/pages/EmailNotVerified.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/pages/emailVerified",
          name: "pageEmailVerified",
          component: () => import("@/views/pages/EmailVerified.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/pages/passwordChangeDone",
          name: "pagePasswordChangeDone",
          component: () => import("@/views/pages/PasswordChangeDone.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        },
        {
          path: "/pages/passwordChangeError",
          name: "pagePasswordChangeError",
          component: () => import("@/views/pages/PasswordChangeError.vue"),
          meta: {
            rule: "hasRoleViewer"
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeEach((to, from, next) => {
  // firebase.auth().onAuthStateChanged(user => {
  //     console.log('wtf');
  //     if (user) {
  //         user.getIdToken().then(function (data) {
  //             console.log('Bearer ', data);
  //         });
  //     }

  //     if (
  //         to.path === "/pages/login" ||
  //         to.path === "/pages/forgot-password" ||
  //         to.path.indexOf("/pages/reset-password") > -1 || // because it is /pages/reset-password/{token}
  //         to.path === "/pages/error-404" ||
  //         to.path === "/pages/register" ||
  //         to.path === "/pages/not-authorized" ||
  //         to.path === "/pages/emailNotVerified" ||
  //         to.path === "/pages/emailVerified" ||
  //         to.path === "/pages/passwordChangeDone" ||
  //         to.path === "/pages/passwordChangeError" ||
  //         to.path === "/callback" ||
  //         (user)
  //     ) {
  //         return next();
  //     }

  //     router.push({ path: '/pages/login', query: { to: to.path } })
  //     // Specify the current path as the customState parameter, meaning it
  //     // will be returned to the application after auth
  //     // auth.login({ target: to.path });

  // });

  if (
    to.path === "/pages/login" ||
    to.path === "/pages/forgot-password" ||
    to.path.indexOf("/pages/reset-password") > -1 || // because it is /pages/reset-password/{token}
    to.path === "/pages/error-404" ||
    to.path === "/pages/register" ||
    to.path === "/pages/not-authorized" ||
    to.path === "/pages/emailNotVerified" ||
    to.path === "/pages/emailVerified" ||
    to.path === "/pages/passwordChangeDone" ||
    to.path === "/pages/passwordChangeError" ||
    to.path === "/callback" ||
    store.state.auth.isUserLoggedIn()
  ) {
    return next();
  }
  // router.push({ path: '/pages/login', query: { to: to.path } })
  return next(); // TODO: interim for a while
});

export default router;
